<template>
  <div class="contentwrapper">
    <div class="content-dark">
      <h1>Thanks for your order</h1>

      <div class="tracker-navigation">
        <button class="button-default">Status</button>
        <button class="button-disabled">Order Details</button>
      </div>

      <tracker :step="1" title="Please check again later" subtitle=""></tracker>

      <div class="more-arrow">
        <img src="@/assets/down-arrow.png" />
        <img src="@/assets/down-arrow.png" />
      </div>
    </div>

    <div class="content-light">
      <h1>Please check again later</h1>

      <p>
        If you are seeing this message and you placed your order in the last hour, please bear with
        us, your order is making it’s way through our system.
      </p>
      <p>
        If you ordered longer than 24 hours ago and are still seeing this view please contact us at
        <a href="mailto:enquiries@magazine.co.uk">enquiries@magazine.co.uk</a> stating the order
        number from your confirmation email.
      </p>
    </div>
  </div>
</template>

<script>
import Tracker from "@/components/Tracker.vue";

export default {
  name: "OrderNotFound",
  components: {
    Tracker
  }
};
</script>
